// The below imports are installed as a dependency of @livongo protobuf packages and don't need to be managed in our project directly
/* eslint-disable node/no-extraneous-import */
import {Empty} from 'google-protobuf/google/protobuf/empty_pb';
import {FieldMask} from 'google-protobuf/google/protobuf/field_mask_pb';
import {Timestamp} from 'google-protobuf/google/protobuf/timestamp_pb';
import {
    BoolValue,
    Int32Value,
    StringValue,
    FloatValue,
    Int64Value,
} from 'google-protobuf/google/protobuf/wrappers_pb';
/* eslint-enable node/no-extraneous-import */
import {
    ChatType,
    ChatSetupModeratorPromiseClient,
    CreateOneOnOneChatRequest,
    CreateRequestCoachRequest,
    GetSendBirdUserCredentialsRequest,
} from '@livongo/protobuf-grpc-external-chat';
import {
    ContentStatus,
    GetCourseSummaryRequest,
    GetDesiredCourseSummaryRequest,
    GetEducationServiceInfoRequest,
    RenderingPromiseClient,
    UserManagerPromiseClient,
    UserActivityPromiseClient,
    GetVideoStatusRequest,
} from '@livongo/protobuf-grpc-external-education';
import {
    BiometricInfoPromiseClient,
    GetBiometricFeedbackRequest,
} from '@livongo/protobuf-grpc-external-biometric_alerts/lib/livongo/protobuf/grpc/external/biometric_alerts/biometricInfo_grpc_web_pb';
import {
    Label as LabelStatus,
    AlertState,
    AlertResult,
    AlertType,
    QuestionAnswer,
} from '@livongo/protobuf-grpc-external-biometric_alerts/lib/livongo/protobuf/common/user/biometricAlerts_pb';
import {
    AlertFlowPromiseClient,
    GetAlertStageRequest,
    UpdateAlertStageRequest,
    ListFlowStagesRequest,
} from '@livongo/protobuf-grpc-external-biometric_alerts/lib/livongo/protobuf/grpc/external/biometric_alerts/alertFlow_grpc_web_pb';
import {
    CreateFoodLogRequestNonStreaming,
    CreateFoodLogsRequestNonStreaming,
    DeleteFoodLogRequest,
    FoodLogCreation,
    UpsertCustomFoodRequest,
    FoodLogServicePromiseClient,
    GetFoodLogHistoryRequest,
    MealTag,
    DataSource,
    UpdateFoodLogRequest,
    GetExternalUserIdRequest,
    ListRecentFoodsRequest,
    GetFoodLogByIdRequest,
    NixFood,
    FoodType,
    FoodItem,
    ExternalFood,
    GetFocusSetupVisibilityRequest,
    UpdateFocusSetupViewStatusRequest,
    GetRecentMealsByTagRequest,
    UpsertMealRequest,
    Meal,
    NutritionInformation,
    NutritionValue,
} from '@livongo/protobuf-grpc-external-food/lib/livongo/protobuf/grpc/external/food/food_grpc_web_pb';
import {
    FoodFocusServicePromiseClient,
    MetricStatus,
    GetNutritionSummariesRequest,
    ListFoodLogFocusesRequest,
    SaveFoodLogFocusRequest,
    DeleteFoodLogFocusRequest,
    GenerateCalorieTargetRequest,
    GetUserHeightWeightInfoRequest,
    FoodLogFocus,
    FoodLogOption,
    FoodLogTarget,
} from '@livongo/protobuf-grpc-external-food/lib/livongo/protobuf/grpc/external/food/focus_grpc_web_pb';
import {
    CoachingSessionManagerPromiseClient,
    ListMemberGoalsRequest,
    ListCoachingSessionsRequest,
    GetCoachingSessionDetailsRequest,
    CoachingStatusManagerPromiseClient,
    GetCoachingFlowStatusRequest,
    GetMemberUpcomingSessions,
    UpdateCoachingFlowStatusRequest,
    CoachingFlowStatus,
    CoachingFlowName,
    GetMemberUpcomingSessionRequest,
} from '@livongo/protobuf-grpc-external-coaching';
import {
    CreateAccessToken as DexcomCreateAccessToken,
    GetAuthorizationStatus as DexcomGetAuthorizationStatus,
    CreateAccessTokenRequest as DexcomCreateAccessTokenRequest,
    AccessToken as DexcomAccessToken,
    GetAuthorizationStatusRequest as DexcomGetAuthorizationStatusRequest,
    AuthorizationStatus as DexcomAuthorizationStatus,
    DexcomAuthorizationServicePromiseClient,
    // eslint-disable-next-line node/no-extraneous-import
} from '@livongo/protobuf-grpc-external-device-cgm2-dexcom-authorization/lib/livongo/protobuf/grpc/external/device/cgm2/dexcom/authorization/authorization_grpc_web_pb';
import {
    CreateAccessToken as AbbottCreateAccessToken,
    GetAuthorizationStatus as AbbottGetAuthorizationStatus,
    CreateAccessTokenRequest as AbbottCreateAccessTokenRequest,
    AccessToken as AbbottAccessToken,
    GetAuthorizationStatusRequest as AbbottGetAuthorizationStatusRequest,
    AuthorizationStatus as AbbottAuthorizationStatus,
    AuthorizationServicePromiseClient,
    // eslint-disable-next-line node/no-extraneous-import
} from '@livongo/protobuf-grpc-external-device-cgm2-authorization/lib/livongo/protobuf/grpc/external/device/cgm2/authorization/authorization_grpc_web_pb';
import {ImageMetadata} from '@livongo/protobuf-common-meta/lib/livongo/protobuf/common/meta/image_pb';
import {AbsoluteTimestamp} from '@livongo/protobuf-common-types/lib/livongo/protobuf/common/types/absoluteTimestamp_pb';
import {
    DiagnosisPromiseClient,
    admin as DiagnosesAndProgramsRequests,
} from '@livongo/protobuf-grpc-external-enrollment/lib/livongo/protobuf/grpc/external/enrollment/diagnosis_api_grpc_web_pb';
import {UserProgramProviderPromiseClient} from '@livongo/protobuf-grpc-external-enrollment/lib/livongo/protobuf/grpc/external/enrollment/user_program_provider_api_grpc_web_pb';
import {
    GetUserProgramsGroupedByProviderRequest,
    GetUserProvidersGroupedByProgramRequest,
} from '@livongo/protobuf-grpc-external-enrollment/lib/livongo/protobuf/grpc/external/enrollment/multibenefit/user_program_provider_pb';
import {DiagnosisType} from '@livongo/protobuf-grpc-external-enrollment/lib/livongo/protobuf/common/user/diagnosis_pb';
import {
    Program as ProgramType,
    ProgramStatus,
} from '@livongo/protobuf-grpc-external-enrollment/lib/livongo/protobuf/common/user/program_pb';
import {
    UserIdType,
    UserId,
} from '@livongo/teladoc-protobuf-common-user-identity/lib/teladoc/protobuf/common/user/identity/userId_pb';
import {
    CommsPreferenceServicePromiseClient,
    GetCommsPreferenceRequest,
    GetOptOutRecordRequest,
    UpdateFeaturePreferenceRequest,
    UpdatePhoneNumberGroupPreferenceRequest,
} from '@livongo/teladoc-protobuf-grpc-comms/lib/teladoc/protobuf/grpc/comms/commsPreference_grpc_web_pb';
import {
    ChannelState,
    FeaturePreference,
    FeatureState,
    PhoneNumberGroupPreference,
    State,
} from '@livongo/teladoc-protobuf-grpc-comms/lib/teladoc/protobuf/common/user/communication/preference_pb';
import {
    Channel,
    Feature,
    PhoneNumberGroup,
} from '@livongo/teladoc-protobuf-grpc-comms/lib/teladoc/protobuf/common/user/communication/comms_pb';
import {Date} from '@livongo/protobuf-grpc-external-enrollment/lib/livongo/protobuf/common/types/date_pb';
import {
    FlowAdminServicePromiseClient,
    GetFlowStatusRequest,
    CreateTeladocSdkInfoRequest,
} from '@livongo/protobuf-grpc-external-med_opt/lib/livongo/protobuf/grpc/external/med_opt/flow_admin_grpc_web_pb';
import {OneAppMigrationPromiseClient} from '@livongo/protobuf-grpc-external-enrollment/lib/livongo/protobuf/grpc/external/enrollment/oneapp_migration_api_grpc_web_pb';
import {GetOneAppMigrationInfoRequest} from '@livongo/protobuf-grpc-external-enrollment/lib/livongo/protobuf/grpc/external/enrollment/oneapp_migration/migration_info_pb';
import {ManageSolutionPromiseClient} from '@livongo/protobuf-grpc-external-enrollment/lib/livongo/protobuf/grpc/external/enrollment/manage_solution_api_grpc_web_pb';
import {CheckProgramEnrollmentEligibilityRequest} from '@livongo/protobuf-grpc-external-enrollment/lib/livongo/protobuf/grpc/external/enrollment/manage_solution/manage_solution_pb';
// SSO (InitializeOneAppEnrollment) imports
import {SsoPromiseClient} from '@livongo/protobuf-grpc-external-enrollment/lib/livongo/protobuf/grpc/external/enrollment/sso_api_grpc_web_pb';
import {
    InitializeOneAppEnrollmentRequest,
    InitializeOneAppEnrollmentResponse,
} from '@livongo/protobuf-grpc-external-enrollment/lib/livongo/protobuf/grpc/external/enrollment/sso/initialize_oneapp_enrollment_pb';
import {getProtoHeaders, setProtoHeaders} from './proto-headers-store';

const SERVICE_URL =
    window?.process?.env?.SERVICE_URL ?? process.env.SERVICE_URL;

const DexcomAuthorizationClient = new DexcomAuthorizationServicePromiseClient(
    SERVICE_URL
);
const AbbottAuthorizationClient = new AuthorizationServicePromiseClient(
    SERVICE_URL
);
const ChatClient = new ChatSetupModeratorPromiseClient(SERVICE_URL);
const ProgramClient = new DiagnosisPromiseClient(SERVICE_URL);
const UserProgramClient = new UserProgramProviderPromiseClient(SERVICE_URL);
const FoodLogClient = new FoodLogServicePromiseClient(SERVICE_URL);
const FoodFocusClient = new FoodFocusServicePromiseClient(SERVICE_URL);
const RenderingClient = new RenderingPromiseClient(SERVICE_URL);
const UserClient = new UserManagerPromiseClient(SERVICE_URL);
const UserActivityClient = new UserActivityPromiseClient(SERVICE_URL);
const BiometricClient = new BiometricInfoPromiseClient(SERVICE_URL);
const AlertFlowClient = new AlertFlowPromiseClient(SERVICE_URL);
const CoachingSessionManagerClient = new CoachingSessionManagerPromiseClient(
    SERVICE_URL
);
const CommsPreferenceServiceClient = new CommsPreferenceServicePromiseClient(
    SERVICE_URL
);
const FlowAdminServiceClient = new FlowAdminServicePromiseClient(SERVICE_URL);
const OneAppMigrationClient = new OneAppMigrationPromiseClient(SERVICE_URL);
const CoachingStatusManagerClient = new CoachingStatusManagerPromiseClient(
    SERVICE_URL
);
const ManageSolutionClient = new ManageSolutionPromiseClient(SERVICE_URL);
const SsoClient = new SsoPromiseClient(SERVICE_URL);

if (
    (window?.process?.env?.ENVIRONMENT ?? process.env.ENVIRONMENT) !==
    'production'
) {
    // eslint-disable-next-line
    const enableDevTools = window.__GRPCWEB_DEVTOOLS__ || (() => {});

    // enable debugging grpc calls
    enableDevTools([
        BiometricClient,
        ChatClient,
        FlowAdminServiceClient,
        FoodLogClient,
        FoodFocusClient,
        ProgramClient,
        UserProgramClient,
        RenderingClient,
        UserClient,
        UserActivityClient,
        CoachingSessionManagerClient,
        OneAppMigrationClient,
        AlertFlowClient,
        CoachingStatusManagerClient,
        SsoClient,
        DexcomAuthorizationClient,
        AbbottAuthorizationClient,
    ]);
}

const {GetDiagnosesAndProgramsResponse: GetProgramsResponse} =
    DiagnosesAndProgramsRequests;
const ProtoUtils = {
    Chat: {
        ChatClient,
        ChatType,
        CreateOneOnOneChatRequest,
        CreateRequestCoachRequest,
        GetSendBirdUserCredentialsRequest,
    },
    Coaching: {
        CoachingSessionManagerClient,
        ListMemberGoalsRequest,
        ListCoachingSessionsRequest,
        GetCoachingSessionDetailsRequest,
        GetCoachingFlowStatusRequest,
        GetMemberUpcomingSessions,
        CoachingStatusManagerClient,
        UpdateCoachingFlowStatusRequest,
        CoachingFlowStatus,
        CoachingFlowName,
        GetMemberUpcomingSessionRequest,
    },
    Program: {
        ProgramType,
        ProgramStatus,
        DiagnosisType,
        ProgramClient,
        UserProgramClient,
        GetProgramsResponse,
        GetUserProgramsGroupedByProviderRequest,
        GetUserProvidersGroupedByProgramRequest,
    },
    Education: {
        ContentStatus,
        GetCourseSummaryRequest,
        GetDesiredCourseSummaryRequest,
        GetEducationServiceInfoRequest,
        RenderingClient,
        UserClient,
        UserActivityClient,
        GetVideoStatusRequest,
    },
    Cgm: {
        DexcomAuthorizationClient,
        DexcomCreateAccessToken,
        DexcomGetAuthorizationStatus,
        DexcomCreateAccessTokenRequest,
        DexcomAccessToken,
        DexcomGetAuthorizationStatusRequest,
        DexcomAuthorizationStatus,
        AbbottAuthorizationClient,
        AbbottCreateAccessToken,
        AbbottGetAuthorizationStatus,
        AbbottCreateAccessTokenRequest,
        AbbottAccessToken,
        AbbottGetAuthorizationStatusRequest,
        AbbottAuthorizationStatus,
    },
    Food: {
        Date,
        AbsoluteTimestamp,
        CreateFoodLogRequestNonStreaming,
        CreateFoodLogsRequestNonStreaming,
        DeleteFoodLogRequest,
        FoodLogClient,
        FoodFocusClient,
        FoodLogCreation,
        UpsertCustomFoodRequest,
        GetFoodLogHistoryRequest,
        ImageMetadata,
        MealTag,
        DataSource,
        UpdateFoodLogRequest,
        GetExternalUserIdRequest,
        ListRecentFoodsRequest,
        GetFoodLogByIdRequest,
        NixFood,
        FoodType,
        FoodItem,
        ExternalFood,
        MetricStatus,
        GetNutritionSummariesRequest,
        GetFocusSetupVisibilityRequest,
        UpdateFocusSetupViewStatusRequest,
        ListFoodLogFocusesRequest,
        SaveFoodLogFocusRequest,
        DeleteFoodLogFocusRequest,
        GenerateCalorieTargetRequest,
        GetUserHeightWeightInfoRequest,
        FoodLogFocus,
        FoodLogOption,
        FoodLogTarget,
        GetRecentMealsByTagRequest,
        UpsertMealRequest,
        Meal,
        NutritionInformation,
        NutritionValue,
    },
    Biometric: {
        LabelStatus,
        BiometricClient,
        GetBiometricFeedbackRequest,
        AlertFlowClient,
        GetAlertStageRequest,
        UpdateAlertStageRequest,
        AlertState,
        AlertResult,
        QuestionAnswer,
        ListFlowStagesRequest,
    },
    CommsPreferences: {
        CommsPreferenceServiceClient,
        GetCommsPreferenceRequest,
        GetOptOutRecordRequest,
        UpdateFeaturePreferenceRequest,
        UpdatePhoneNumberGroupPreferenceRequest,
        ChannelState,
        FeaturePreference,
        FeatureState,
        PhoneNumberGroupPreference,
        State,
        Channel,
        Feature,
        PhoneNumberGroup,
    },
    Identity: {
        UserId,
        UserIdType,
    },
    MedOpt: {
        AlertState,
        AlertType,
        GetFlowStatusRequest,
        FlowAdminServiceClient,
        CreateTeladocSdkInfoRequest,
    },
    Google: {
        BoolValue,
        Empty,
        FieldMask,
        Int32Value,
        Timestamp,
        StringValue,
        FloatValue,
        Int64Value,
    },
    Migration: {
        OneAppMigrationClient,
        GetOneAppMigrationInfoRequest,
    },
    ManageSolution: {
        ManageSolutionClient,
        CheckProgramEnrollmentEligibilityRequest,
    },
    Sso: {
        SsoClient,
        InitializeOneAppEnrollmentRequest,
        InitializeOneAppEnrollmentResponse,
    },
    // list of gRPC defined status codes https://grpc.github.io/grpc/core/md_doc_statuscodes.html
    STATUSES: {
        OK: 0,
        CANCELLED: 1,
        UNKNOWN: 2,
        INVALID_ARGUMENT: 3,
        DEADLINE_EXCEEDED: 4,
        NOT_FOUND: 5,
        ALREADY_EXISTS: 6,
        PERMISSION_DENIED: 7,
        RESOURCE_EXHAUSTED: 8,
        FAILED_PRECONDITION: 9,
        ABORTED: 10,
        OUT_OF_RANGE: 11,
        UNIMPLEMENTED: 12,
        INTERNAL: 13,
        UNAVAILABLE: 14,
        DATA_LOSS: 15,
        UNAUTHENTICATED: 16,
    },

    getHeaders() {
        return getProtoHeaders();
    },
    setHeaders(attributes) {
        setProtoHeaders(attributes);
    },
};

export default ProtoUtils;
